import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import i18n from 'I18n';
import {
  defaultHeaderConfig,
  headerConfig,
} from 'frontend_common/HeaderConfig';

import SelectLanguage from 'component/common/navigator/SelectLanguage';

import { APP_NAME, SHOW_FOOTER } from 'utils/Config';
import { isMobile } from 'utils/ScreenUtils';

import './Footer.scss';

const Footer = ({ language }) => {
  const location = useLocation();
  const [navBarConfig, setNavBarConfig] = useState({});
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const isSelectStorePage = location.pathname.indexOf('/select_store') !== -1;

  const isHomepage = location.pathname.indexOf('/home') !== -1;

  const isOfferPage = location.pathname.indexOf('/offer/') !== -1;
  const isUseCashDollarPage =
    location.pathname.indexOf('/use_cash_dollar') !== -1;
  const hideFooter = isSelectStorePage || isUseCashDollarPage || !SHOW_FOOTER;

  const footerBackgroundColorG8 = isHomepage || isOfferPage;
  const currentYear = new Date().getFullYear();

  const isMobileView = isMobile();

  useEffect(() => {
    let config = defaultHeaderConfig;
    headerConfig.forEach((item) => {
      if (location.pathname.indexOf(item.pathname) !== -1) {
        config = item;
      }
    });
    setNavBarConfig(config);
  }, [location]);

  return (
    <>
      {hideFooter ? null : (
        <Container
          className={
            footerBackgroundColorG8
              ? 'footer_container background-greyG8'
              : 'footer_container'
          }
        >
          <footer className="page_footer container">
            <div className="footer_left">
              <Link
                className="footer_link tag-menu-1"
                to={{
                  pathname: `${process.env.REACT_APP_TERM_CONDITIONS_LINK}?lang=${language}`,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n.t('sign_up_terms_conditions')}
              </Link>
              <Link
                className="footer_link tag-menu-1"
                to={{
                  pathname: `${process.env.REACT_APP_PRIVACY_LINK}?lang=${language}`,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n.t('sign_up_privacy_policy')}
              </Link>
              <label className="copyright tag-menu-1">
                © 2019-{currentYear} {APP_NAME}. {i18n.t('all_rights_reserved')}
              </label>
            </div>

            {!isMobileView &&
            !navBarConfig.webShowSideMenu &&
            !navBarConfig.webShowLanguage ? (
              <SelectLanguage
                languageDropdownOpen={languageDropdownOpen}
                setLanguageDropdownOpen={setLanguageDropdownOpen}
                extraContainerClassName="tag-menu-1"
              />
            ) : null}
          </footer>
        </Container>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  language: state.users.language,
});

export default connect(mapStateToProps)(Footer);
